import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  ngOnInit(): void {
    localStorage.getItem("translate") ? console.log(localStorage.getItem("translate")) : localStorage.setItem("translate", 'idn')
  }
  title = 'sapp';


}
